import { motion, useReducedMotion } from "framer-motion";

// Line-by-line masked reveal for hero headings
export function MaskLine({ children, delay = 0, className = "" }) {
  const reduce = useReducedMotion();
  return (
    <span className="reveal-mask">
      <motion.span
        className={`block ${className}`}
        initial={reduce ? { opacity: 0 } : { y: "110%" }}
        animate={reduce ? { opacity: 1 } : { y: 0 }}
        transition={{ ease: [0.76, 0, 0.24, 1], duration: 1.2, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

// Scroll-triggered fade/slide up reveal
export function Reveal({ children, delay = 0, y = 40, className = "", once = true }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
